import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./StackedCards.css";
import { fetchCaseStudies } from "../services/airtable";
// Fallback to static data if Airtable fails
import staticCaseStudies from "./caseStudiesData";

export default function StackedCards() {
  const [caseStudies, setCaseStudies] = useState(staticCaseStudies);

  useEffect(() => {
    const loadCaseStudies = async () => {
      try {
        const airtableData = await fetchCaseStudies();
        if (airtableData && airtableData.length > 0) {
          // Filter only featured case studies for home page
          const featuredData = airtableData.filter(study => study.featuredOnHome);
          console.log('Featured case studies for home page:', featuredData.length);
          
          // Transform Airtable data to match existing format with images array
          const transformedData = featuredData.map(study => ({
            clientName: study.clientName,
            title: study.title,
            description: study.subtitle,
            slug: study.slug,
            image: study.heroImageUrl || require('../assets/cjm2.png'),
            images: [study.heroImageUrl || require('../assets/cjm2.png')] // Keep images array for compatibility
          }));

          console.log('Transformed data:', transformedData);
          
          // If no featured studies, fall back to static data to maintain 3 cards
          if (transformedData.length === 0) {
            console.log('No featured case studies found, using static data');
            setCaseStudies(staticCaseStudies);
          } else {
            setCaseStudies(transformedData);
          }
        }
      } catch (error) {
        console.error('Failed to load case studies from Airtable, using static data:', error);
        // Keep using static data as fallback
      }
    };

    loadCaseStudies();
  }, []);
  useEffect(() => {
    const stickyCards = document.querySelectorAll('.sticky-card');
    
    const observerOptions = {
      root: null,
      rootMargin: '-80px 0px -20% 0px',
      threshold: [0, 0.1, 0.9, 1]
    };

    const updateCardPositions = () => {
      const visibleCards = [];
      const stickyPositions = [150, 170, 190]; // Match the CSS top values
      
      stickyCards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const expectedTop = stickyPositions[index];
        const isStuck = rect.top <= expectedTop + 5 && rect.bottom > expectedTop;
        
        if (isStuck) {
          visibleCards.push(index);
        }
      });

      // Reset all cards to center first
      stickyCards.forEach((card, index) => {
        card.style.transform = 'translateX(0)';
      });

      // Then apply offsets for stacked cards
      if (visibleCards.length > 1) {
        visibleCards.forEach((cardIndex, stackPosition) => {
          if (stackPosition < visibleCards.length - 1) {
            const card = document.querySelector(`[data-index="${cardIndex}"]`);
            const offset = (visibleCards.length - stackPosition - 1) * 24;
            if (card) {
              card.style.transform = `translateX(${offset}px)`;
            }
          }
        });
      }
    };

    const observer = new IntersectionObserver(updateCardPositions, observerOptions);
    
    // Also listen to scroll events for smoother updates
    const handleScroll = () => {
      requestAnimationFrame(updateCardPositions);
    };

    // Observe all cards
    stickyCards.forEach(card => observer.observe(card));
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <section className="stacked-cards-section">
      <div className="sticky-case-studies-header">
        <h2 className="section-title">Explore My Work</h2>
      </div>
      <div className="stacked-cards-list">
        {caseStudies.slice(0, 3).map((caseStudy, i) => (
          <div className="sticky-card" key={i} data-index={i}>
            <div className="stacked-card">
              <div className="card-mobile-layout">
                {/* Client name - mobile order 1 */}
                {caseStudy.clientName && <div className="client-name">{caseStudy.clientName}</div>}

                {/* Title - mobile order 2 */}
                <h3>{caseStudy.title}</h3>

                {/* Image - mobile order 3 */}
                <div className="card-image-mobile">
                  {caseStudy.images ?
                    caseStudy.images.map((img, idx) => (
                      <img src={img} alt="" key={idx} className="case-study-image" />
                    )) :
                    <img src={caseStudy.image} alt={caseStudy.title} className="case-study-image" />
                  }
                </div>

                {/* Description - mobile order 4 */}
                <p>{caseStudy.description ? (() => {
                  let cleanedText = caseStudy.description.replace(/\|\*\|\*/g, '**').replace(/\\\*\\\*/g, '**');
                  return cleanedText.includes('**') ?
                    cleanedText.split(/(\*\*.*?\*\*)/).map((part, index) =>
                      part.startsWith('**') && part.endsWith('**') ?
                        <strong key={index}>{part.slice(2, -2)}</strong> : part
                    ) : cleanedText;
                })() : ''}</p>

                {/* Button - mobile order 5 */}
                {caseStudy.slug ? (
                  <Link
                    to={`/case-studies/${caseStudy.slug}`}
                    className="btn btn-primary"
                  >
                    View Study
                  </Link>
                ) : (
                  <span className="btn btn-primary" style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    Coming Soon
                  </span>
                )}
              </div>

              {/* Desktop layout - hidden on mobile */}
              <div className="card-desktop-layout">
                <div className="card-left">
                  {caseStudy.clientName && <div className="client-name">{caseStudy.clientName}</div>}
                  <h3>{caseStudy.title}</h3>
                  <p>{caseStudy.description ? (() => {
                    let cleanedText = caseStudy.description.replace(/\|\*\|\*/g, '**').replace(/\\\*\\\*/g, '**');
                    return cleanedText.includes('**') ?
                      cleanedText.split(/(\*\*.*?\*\*)/).map((part, index) =>
                        part.startsWith('**') && part.endsWith('**') ?
                          <strong key={index}>{part.slice(2, -2)}</strong> : part
                      ) : cleanedText;
                  })() : ''}</p>
                  {caseStudy.slug ? (
                    <Link
                      to={`/case-studies/${caseStudy.slug}`}
                      className="btn btn-primary"
                    >
                      View Study
                    </Link>
                  ) : (
                    <span className="btn btn-primary" style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                      Coming Soon
                    </span>
                  )}
                </div>
                <div className="card-right">
                  {caseStudy.images ?
                    caseStudy.images.map((img, idx) => (
                      <img src={img} alt="" key={idx} className="case-study-image" />
                    )) :
                    <img src={caseStudy.image} alt={caseStudy.title} className="case-study-image" />
                  }
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="view-more-case-studies">
        <Link to="/case-studies" className="btn btn-primary">
          View more
        </Link>
      </div>
    </section>
  );
} 